import lottie from 'lottie-web'
import { isNull } from '../misc/Utils'

export default class ArticleVideo {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.video = document.querySelectorAll('.video-element')
        this.videoPoster = document.querySelectorAll('.video-poster')
        this.videoTrigger = document.querySelectorAll('.video-trigger')
    }

    bindEvents() {
        if (isNull(this.videoTrigger)) {
            return
        }

        Array.prototype.forEach.call(this.videoTrigger, (element, i) => {
            this.intializeButtons(element, i)
        })
    }

    intializeButtons(element, i) {
        const target = element
        const button = element.querySelector('.play-button')

        const animate = lottie.loadAnimation({
            container: button,
            path: 'https://assets1.lottiefiles.com/private_files/lf30_gq5ezxek.json',
            renderer: 'svg',
            loop: false,
            autoplay: false,
            name: 'play',
        })

        target.addEventListener('mouseout', () => {
            animate.stop()
        })

        target.addEventListener('mouseover', () => {
            animate.play()
        })

        target.addEventListener('click', () => {
            this.videoPoster[i].classList.add('is-playing')
            this.video[i].play()
        })

        this.video[i].addEventListener('ended', () => {
            this.videoPoster[i].classList.remove('is-playing')
        })

        this.video[i].addEventListener('pause', () => {
            this.videoPoster[i].classList.remove('is-playing')
        })
    }
}
